import { HelpMessage } from 'utils/constants'
import CIMSFormItem from 'components/CIMSFormItem'
import NameFormItem from 'components/CIMSFormItem/common/NameFormItem'
import DescriptionFormItem from 'components/CIMSFormItem/common/DescriptionFormItem'
import PermissionEditor from '../../../../../../../../PermissionEditor'

export const EditRoleModalBody: React.FC = () => {
  return (
    <>
      <NameFormItem help={HelpMessage.Administration.Roles.Name} />
      <DescriptionFormItem entityName="Role" />
      <CIMSFormItem name={'permissionIds'}>
        <PermissionEditor help={HelpMessage.Administration.Roles.Permissions} />
      </CIMSFormItem>
    </>
  )
}

export type EditRoleModalValues = {
  name: string
  description?: string | null
  permissionIds: string[]
}
